
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"6","viewBox":"0 0 11 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.48877 1.92494L9.20279 5.7689C9.49685 6.07703 9.97416 6.07703 10.2682 5.7689C10.5623 5.46076 10.5623 4.96059 10.2682 4.65245L5.99094 0.218265C5.71322 -0.0727549 5.26361 -0.0727549 4.98659 0.218265L0.709314 4.65245C0.415255 4.96059 0.415255 5.46076 0.709314 5.7689C1.00337 6.07703 1.48069 6.07703 1.77475 5.7689L5.48877 1.92494Z","fill":"url(#paint0_linear_1445_783)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_1445_783","x1":"10.4888","y1":"3.04225","x2":"0.48877","y2":"3.04225","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#3F7AF8"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#8A53F7"}})])])])
          )
        }
      }
    